<template>
    <i class="primary-color fa fa-download pointer" title="Download Template" aria-hidden="true" @click="onClickcsvDownload"></i>
</template>
<style lang="scss" scoped>
  .fa-download{
    position: relative;
    top: 2px;
  }
</style>
<script>
import axios from "axios"
export default {
  name: "CsvDownload",
  props: {
    propModuleFile: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      cvBtnCSvDownload: "Download Csv"
    }
  },
  methods: {
    async onClickcsvDownload () {
      try {
        let resp = await axios({ url: `/csv_templates/${this.propModuleFile}.csv`, method: "GET", responseType: "blob" })
        let downloadUrl = window.URL.createObjectURL(new Blob([ resp.data ]))
        let downloadLink = document.createElement("a")
        downloadLink.setAttribute("download", `${this.propModuleFile}.csv`)
        downloadLink.href = downloadUrl
        downloadLink.click()
      }
      catch (err) {
        console.error("Exception occurred at csvDownload() and Exception:", err.message)
      }
    }
  }
}
</script>
<style>
  .fa-download{
    /* color: #e5252e; */
  }
</style>
